import InterventionPrivateApiModel from '../../abstracts/InterventionPrivateApiModel';

export default class ExportReadModel extends InterventionPrivateApiModel {
	static get path(): string {
		return '/exports/{?id}/read';
	}
}
